// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    orders: [],  // changed from single order to array
    serviceRequests: [],
};

const detailsSlice = createSlice({
    name: 'details',
    initialState,
    reducers: {
        setOrders: (state, action) => {
            state.orders = action.payload;
        },
        addOrder: (state, action) => {
            if (!state.orders) state.orders = [];
            state.orders.push(action.payload);
        },
        clearOrders: (state) => {
            state.orders = [];
        },
        updateOrder: (state, action) => {
            if (!state.orders) state.orders = [];
            const updatedOrder = action.payload;
            const index = state.orders.findIndex(order => order.id === updatedOrder.id);
            if (index !== -1) {
                state.orders[index] = updatedOrder;
            } else {
                state.orders.push(updatedOrder);
            }
        },
        setServiceRequests: (state, action) => {
            state.serviceRequests = action.payload;
        },
        addServiceRequest: (state, action) => {
            if (!state.serviceRequests) state.serviceRequests = [];
            state.serviceRequests.push(action.payload);
        },
        updateServiceRequest: (state, action) => {
            if (!state.serviceRequests) state.serviceRequests = [];
            const updatedRequest = action.payload;
            const index = state.serviceRequests.findIndex(req => req.id === updatedRequest.id);
            if (index !== -1) {
                state.serviceRequests[index] = updatedRequest;
            } else {
                state.serviceRequests.push(updatedRequest);
            }
        },
    },
});

export const {
    setOrders,
    addOrder,
    clearOrders,
    updateOrder,
    setServiceRequests,
    addServiceRequest,
    updateServiceRequest
} = detailsSlice.actions;

export const selectOrders = (state) => state.details.orders || [];
export const selectServiceRequests = (state) => state.details.serviceRequests || [];

export default detailsSlice.reducer;
